import { setSpecificMessage, notGraphemes } from "valibot";
setSpecificMessage(
  notGraphemes,
  (issue) => `Graphèmes invalide: attendu ${issue.expected}, mais reçu ${issue.received}`,
  "fr"
);